import { render, staticRenderFns } from "./rating-question.vue?vue&type=template&id=2eae2b25&scoped=true"
import script from "./rating-question.vue?vue&type=script&lang=js"
export * from "./rating-question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eae2b25",
  null
  
)

export default component.exports